<template>
  <div class="iconography-intro-content-wrapper" id="identidade-visual-iconografia-introducao-estilo" data-search-anchor>
    <div class="iconography-intro-content">
      <div class="description-iconography-content">
        <div class="title-iconography-intro-wrapper">
          <h1 class="iconography-intro-title-span">{{ iconographyIntroTitleSpan }}</h1>
          <h1 class="iconography-intro-title">{{ iconographyIntroTitle }}</h1>
        </div>

        <p class="iconography-intro-description-paragraph">
          {{ iconographyIntroDescriptionParagraph1 }}
        </p>
        <p class="iconography-intro-description-paragraph">
          {{ iconographyIntroDescriptionParagraph2 }}
        </p>
        <p class="iconography-intro-description-paragraph">
          {{ iconographyIntroDescriptionParagraph3 }}
        </p>

        <div class="button-iconography-intro-wrapper">
          <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar ícones"          
        />       
        </div>
      </div>

      <div class="iconography-intro-card-item">
        <video
          class="iconography-intro-card-item"
          :src="iconographyIntroImageSrc"
          autoplay
          muted
          loop
          playsinline
        ></video>
      </div>
    </div>

    <div
      class="iconography-intro-card-item-bottom-2"
      :style="{ backgroundImage: `url(${iconographyIntroImageSrcBottom2})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import IconographyPageMixin from '@/mixins/iconography-page-mixin'
import { IconographyPageStore } from '@/store/visual-identity-page/iconography-page'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'


@Component({})
export default class IconographyIntroSection extends Mixins(IconographyPageMixin) {
  iconographyPageStore: PageStoreContract = getModule(IconographyPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Iconografia'

  get iconographyIntroTitleSpan(): string {
    return this.getElementTitle(1, 0)
  }
  get iconographyIntroTitle(): string {
    return this.getElementText(1, 0)
  }
  get iconographyIntroDescriptionParagraph1(): string {
    return this.getElementText(1, 1)
  }
  get iconographyIntroDescriptionParagraph2(): string {
    return this.getElementText(1, 2)
  }
  get iconographyIntroDescriptionParagraph3(): string {
    return this.getElementText(1, 3)
  }
  get iconographyIntroImageSrc(): string {
    return this.getElementMedia(1, 4)
  }
  get iconographyIntroImageSrcBottom2(): string {
    return this.getElementMedia(1, 6)
  }  

  async getGraphicPage(): Promise<void> {
    await this.iconographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.iconographyPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.iconography-intro-content-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 1032px;
  width: 100%;
}

.iconography-intro-content {
  display: grid;
  grid-template-columns: 56% 44%;
  justify-content: space-between;

  max-width: 1032px;
  width: 100%;
}

.title-iconography-intro-wrapper {
  display: flex;
  align-items: center;
}

.iconography-intro-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.iconography-intro-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.iconography-intro-description-paragraph {
  white-space: pre-line;
}

.description-iconography-content {
  width: 488px;

  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.iconography-intro-card-item {
  position: relative;
  max-width: 754px;
  width: 100%;
  margin-top: -30px;
  margin-bottom: 1rem;

  video {
    height: auto;
  }
}

.iconography-intro-card-item-bottom-1 {
  position: relative;
  left: 3.8rem;
  bottom: 8rem;

  max-width: 405px;
  width: 100%;
  height: 255px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.iconography-intro-card-item-bottom-2 {
  position: relative;

  max-width: 1032px;
  width: 100%;
  height: 629px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.button-iconography-intro-wrapper {
  display: flex;
  align-items: center;
  padding-right: 5rem;
  padding-top: 3rem;
}
</style>
